module.exports = __webpack_public_path__ + "img/shorts-red.d4627641.svg";